import React from 'react';
import css from './Checkbox.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
    isChecked: boolean;
    disabled?: boolean;
    testId?: string;
    onClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function Checkbox({ children, className, isChecked, disabled = false, testId = 'checkbox', onClick }: Props){
    return (<label className={`${css.item} ${className}`}>
        <input className={css.input} type="checkbox" checked={isChecked} onChange={onClick} disabled={disabled} data-testid={`${testId}-chk`}/>
        <span className={css.checkmark} data-testid={testId}></span>
        {children}
    </label>)
}

export default Checkbox;